import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './AdminProtalV2/App/App/App.jsx';
import reportWebVitals from './reportWebVitals.js';
import store from './store.js';
import { Provider } from 'react-redux';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
